import { render, staticRenderFns } from "./attribute-editor.vue?vue&type=template&id=38cad665"
import script from "./attribute-editor.vue?vue&type=script&lang=js"
export * from "./attribute-editor.vue?vue&type=script&lang=js"
import style0 from "./attribute-editor.vue?vue&type=style&index=0&id=38cad665&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports